import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-invitation-form',
  templateUrl: './email-invitation-form.component.html',
  styleUrls: ['./email-invitation-form.component.css','../../admin.css']
})
export class EmailInvitationFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/email/invitation-form/email-invitation-form.component.ts